module.exports = [{"title":"Customer","xLeft":10,"yTop":60,"size_w":600,"size_h":300,"og_size_w":600,"og_size_h":300,"zIndex":49,"fields":["Name","Address","Phone"],"buttons":["Submit","Cancel"],"actions":["customer_submit","customer_cancel"]},{"title":"Business","xLeft":10,"yTop":380,"size_w":600,"size_h":600,"og_size_w":600,"og_size_h":600,"zIndex":50,"fields":["Name","Address","Phone","Account Number","Billing Contact","Tracking","E-Mail"],"buttons":["Accept","Update","Cancel"],"actions":["business_accept","business_update","business_cancel"]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/windowed/windowData.json
// module id = 571
// module chunks = 0